import { Helmet } from "react-helmet-async";
import {
  SEO_SITE_NAME,
  SEO_DEFAULT_TITLE,
  SEO_DEFAULT_DESC,
  SEO_BASE_URL,
} from "@/config";

export function Seo({ title, description, path = "", image, type = "website", keywords }) {
  const fullTitle = title ? `${title} | ${SEO_SITE_NAME}` : SEO_DEFAULT_TITLE;
  const desc = description || SEO_DEFAULT_DESC;
  const url = `${SEO_BASE_URL}${path}`;
  const ogImage = image || `${SEO_BASE_URL}/logo192.png`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SEO_SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="de_DE" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
